import { AriaToastRegion, KdsToast } from "@kazaar-platform/design-system";

import { useToasts } from "@/hooks";

export const Toasts = () => {
  const { queue } = useToasts();

  const handleClose = (key: string) => queue.close(key);

  return (
    <AriaToastRegion queue={queue}>
      {({ toast }) => (
        <KdsToast {...toast.content} toast={toast} handleClose={handleClose} />
      )}
    </AriaToastRegion>
  );
};
